import { getters } from "@/constants/state";

export default {
  [getters.COMMENTS_GETTER]: (state) => state.comments,
};
